var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.TableHelper,{attrs:{"fields":_setup.fields,"items":_setup.stoppedIterations,"meta":_setup.meta,"disable-search":"","disable-skeleton-loading":"","loading-key":"loadJobs","title":_vm.$t('salesChannelManagementApp.usedFilters')},on:{"reload-data":_setup.getAllFinishedIterations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }